import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Capsule = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M8.999 20.133a4.969 4.969 0 003.536-1.465l7.134-7.133a5.007 5.007 0 00-.001-7.072C18.723 3.52 17.467 3 16.132 3s-2.591.52-3.534 1.464l-7.134 7.134a5.009 5.009 0 000 7.072 4.97 4.97 0 003.535 1.463zm5.013-14.255A2.979 2.979 0 0116.132 5c.802 0 1.556.313 2.122.878a3.004 3.004 0 01.001 4.243l-2.893 2.892L11.12 8.77l2.892-2.892zm-7.134 7.134l2.828-2.828 4.242 4.243-2.827 2.827c-1.133 1.133-3.11 1.132-4.243.001a3.005 3.005 0 010-4.243z",
    key: "k0"
  }));
});
Capsule.displayName = 'Capsule';
export var CapsuleDimensions = {
  height: 24,
  width: 24
};